import { FeatureContent } from "@/lib/features/content";
import { CSSProperties } from "react";
import BasicBlock from "../shared/basic-block";
import { useStrings } from "@/lib/i18n/context";

interface FeatureStepsProps {
  featureContent: FeatureContent;
}

const FeatureSteps = ({ featureContent }: FeatureStepsProps) => {
  const s = useStrings();
  if (!featureContent.stepImages?.length) return null;

  return (
    <BasicBlock
      header={s.feature.stepsHeader}
      contentStyle="flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap"
    >
      {featureContent.stepImages.map((image, index, arr) => {
          return (
            <img
              key={index}
              src={image}
              alt={`${s.feature.stepAlt} ${index + 1}`}
              className="w-full rounded-2xl border-2 border-[#F7F7F7] object-contain sm:[flex-basis:var(--step-size)] sm:[max-width:var(--step-size)]"
              draggable={false}
              style={
                {
                  "--step-size": `calc((100% - 12px * (${arr.length} - 1)) / ${arr.length})`,
                  touchAction: "none",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                } as CSSProperties
              }
            />
          );
        })}
    </BasicBlock>
  );
};

export default FeatureSteps;
